export const RECOMMENDED = 'RECOMMENDED';
